import { useEffect, useState } from "react";
import { Card, Collapse, Tabs } from "antd";
import { Link, useNavigate } from "react-router-dom";
import {
  FiChevronDown,
  FiChevronUp,
  FiMapPin,
  FiPhone,
  FiShare2,
} from "react-icons/fi";

// ------------------- modals
import RegisterModal from "../../components/Modals/Register";
import VerifyModal from "../../components/Modals/Visit";
import UserInfoModal from "../../components/Modals/Visit/getUserInfo";

// ------------------- days_week
import days_week from "../../constants/days";

// ------------------- css
import "./style.css";
import axios from "axios";
import { api } from "../../api/url";
import { useParams } from "react-router-dom";

const TabContent = (props) => {
  const Onclick = (item) => {
    props.changeActive_time(item);
    // props.setOpen(true);
  };

  return (
    <div className="visit-page-time-content">
      {props?.days?.map((item) => (
        <div className="col-6 col-sm-4 col-xl-3 col-xxl-2 col-lg-3  col-md-3">
          <div
            onClick={() => (item.patientId ? null : Onclick(item))}
            className={
              item.patientId
                ? "visit-page-time-item-deactive"
                : item?.reserveNo === props?.active_time?.reserveNo
                  ? "visit-page-time-item  active-time"
                  : "visit-page-time-item "
            }
          >
            {item?.startTime + " - " + item?.endTime}
          </div>
        </div>
      ))}
    </div>
  );
};

const Divider = () => <span className="header-divider">-</span>;
const p2e = (s) => s.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));

const DoctorPage = () => {
  const { id, doctorid } = useParams();
  const navigation = useNavigate();
  const [doctor, changeDoctor] = useState();
  const [user, changeUser] = useState();
  const [doctor_address, changeDoctor_Address] = useState("");
  const [cmpnyID, changeCmpnyID] = useState();
  const [loading, setLoading] = useState();
  const [visitInfo, setVisitInfo] = useState();

  const [days, setDays] = useState([]);
  const [shifts, setShifts] = useState([]);
  const [active_day, changeActive_day] = useState(0);
  const [active_time, changeActive_time] = useState();
  // ------------------- modals states
  const [open, setOpen] = useState(false);
  const [openVisitModal, setVisitModal] = useState(false);
  const [openVisitInfoModal, setVisitInfoModal] = useState(false);

  const onChange = (key) => {
    // console.log(key);
  };

  // ------------------- Get doctor info
  const GetDoctor = async () => {
    setLoading(true);
    await axios({
      url: api + "appointment/attender/get/" + doctorid,
      method: "get",

    })
      .then((res) => {
        changeDoctor(res.data.data);
        let branch = "",
          compannyId = null;

        // ------------------- to find address of branch
        res.data.data.companyList.map((item) =>
          item.branchList.map((brnch) => {
            if (String(brnch.id) === String(id)) {
              branch = brnch.name;
              compannyId = item.id;
            }
          })
        );
        changeDoctor_Address(branch);
        changeCmpnyID(compannyId);
        setLoading(false);
      })
      .catch((err) => {
        console.log("err", err);
        setLoading(false);
      });
  };

  // ------------------- Get visit dates
  const GetScheduleTimes = async (date) => {
    await axios({
      url: api + "appointment/getschedule",
      method: "post",
      data: {
        pageNo: 0,
        pageRowsCount: 10,
        attenderId: doctorid,
        branchId: id,
        appointmentDatePersian: date,
      },
    })
      .then((res) => {
        let shifts_arr = res.data.data.map((item, index) => {
          return {
            label: item.name,
            key: String(index),
            children: (
              <TabContent
                changeActive_time={changeActive_time}
                active_time={null}
                days={item.scheduleBlock}
                setOpen={ClickOnDays}
              />
            ),
          };
        });

        setShifts(shifts_arr);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const GetTimes = async () => {
    let day = new Date();
    let nextDay = new Date(day);
    nextDay.setDate(day.getDate() + 10);

    await axios({
      url: api + "appointment/getdays",
      method: "post",
      data: {
        pageNo: 0,
        pageRowsCount: 10,
        fromDateTimePersian: p2e(day.toLocaleString("Fa").split(",")[0]),
        toDateTimePersian: p2e(nextDay.toLocaleString("Fa").split(",")[0]),
        attenderId: doctorid,
        branchId: id,
      },
    })
      .then((res) => {
        setDays(res.data.data);

        if (res?.data?.data[0])
          GetScheduleTimes(res?.data?.data[0]?.appointmentDatePersian);
        // changeDoctor(res.data.data);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    GetDoctor();
    GetTimes();
  }, [id]);

  const ClickOnDays = () => {
    if (localStorage.getItem("token")) ReserveTime();
    else setOpen(true);
  };

  useEffect(() => {
    console.log('activetime', active_time)
    if (active_time) ClickOnDays();
  }, [active_time]);

  const closeFunction = () => {
    changeActive_time()
  }

  const ReserveTime = async () => {
    let userID = await localStorage.getItem("user");
    localStorage.setItem("active_time", JSON.stringify(active_time));
    navigation(
      "/factor/" +
      doctorid +
      "/" +
      id +
      "?day=" +
      days[active_day]?.appointmentDatePersian +
      "&time=" +
      active_time?.endTime +
      "-" +
      active_time?.startTime +
      "&blockId=" +
      active_time?.attenderScheduleBlockId
    );
  };

  // await axios({
  //   url: api + "appointment/admission/getinfo",
  //   method: "post",
  //   data: {
  //     userId: userID,
  //     attenderId: doctorid,
  //     serviceId: doctor?.serviceId,
  //     companyId: cmpnyID,
  //     branchId: id,
  //   },
  //   headers: {
  //     Authorization: "Bearer " + localStorage.getItem("token"),
  //   },
  // })
  //   .then((res) => {
  //     //  user must complete profile first
  //     if (
  //       res?.data?.data?.userFirstName &&
  //       res?.data?.data?.userLastName &&
  //       res?.data?.data?.userNationalCode
  //     ) {
  //       localStorage.setItem("active_time", JSON.stringify(active_time));
  //       navigation(
  //         "/factor/" +
  //         doctorid +
  //         "/" +
  //         id +
  //         "?day=" +
  //         days[active_day]?.appointmentDatePersian +
  //         "&time=" +
  //         active_time?.endTime +
  //         "-" +
  //         active_time?.startTime +
  //         "&blockId=" +
  //         active_time?.attenderScheduleBlockId
  //       );
  //       // setVisitInfo(res.data.data);
  //       // setVisitModal(true);
  //     } else {
  //       setVisitInfoModal(true);
  //       changeUser({
  //         firstName: res?.data?.data?.userFullName,
  //         lastName: res?.data?.data?.userFullName,
  //         userNationalCode: res?.data?.data?.userNationalCode,
  //         mobileNo: localStorage.getItem("cellphone"),
  //       });
  //     }
  //   })
  //   .catch((err) => {
  //     console.log("err", err);
  //     if (err.response.status === 401) {
  //       localStorage.clear();
  //       setOpen(true);
  //     }
  //     // setVisitModal(true);
  //   });

  if (doctor)
    return (
      <div className="doctors-page-container single-doctor-page-container">
        <div class="row">
          <div class="col-lg-8 department-description-container">
            <Card className="visit-page-header-card">
              <div className="visit-page-header">
                <img
                  src={
                    doctor?.attenderGenderId === 1
                      ? require("../../assets/images/man.png")
                      : require("../../assets/images/woman.png")
                  }
                  className="doctor-avatar"
                  alt="doctor-avatar"
                />
                <div className="single-doctor-page-info visit-page-doctor-info">
                  <h5>{doctor?.attenderFullName}</h5>
                  <Divider />
                  <span className="single-doctor-page-special">
                    تخصص: {doctor?.specialityName}
                  </span>
                  <Divider />
                  <span className="single-doctor-page-id">
                    شماره نظام پزشکی: {doctor?.attenderMsc}
                  </span>
                </div>
                {/* <FiShare2 className="single-doctor-page-share visit-page-share" /> */}
              </div>
            </Card>

            <Card className="visit-page-table-card">
              <div className="visit-page-location">
                <FiMapPin />
                {doctor_address}
              </div>
              <div className="visit-page-time-container">
                <div className="visit-page-day-container ">
                  {days.map((item, index) => (
                    <div
                      onClick={() => {
                        changeActive_day(index);
                        GetScheduleTimes(item.appointmentDatePersian);
                      }}
                      className={
                        index === active_day
                          ? "visit-page-day-item active-day "
                          : "visit-page-day-item"
                      }
                    >
                      <span>{days_week[item.dayInWeekFa - 1]}</span>
                      <span>{item.appointmentDatePersian}</span>
                    </div>
                  ))}
                </div>
                {shifts && (
                  <Tabs
                    style={{ width: "100%" }}
                    rootClassName="visit-page-tabs"
                    defaultActiveKey="1"
                    items={shifts}
                    onChange={onChange}
                  />
                )}
              </div>
            </Card>
          </div>
          <SideBar companies={doctor?.companyList} id={id} />
        </div>
        {visitInfo && (
          <VerifyModal
            open={openVisitModal}
            setOpen={setVisitModal}
            visitInfo={visitInfo}
            active_time={active_time}
            active_date={days[active_day]}
          />
        )}
        {user && (
          <UserInfoModal
            user={user}
            open={openVisitInfoModal}
            setOpen={setVisitInfoModal}
          />
        )}
        <RegisterModal
          open={open}
          setOpen={setOpen}
          ReserveFunc={ReserveTime}
          hasReserve={true}
          closeFunction={closeFunction}
        />
      </div>
    );
  else return <div>loading</div>;
};

export default DoctorPage;

const SideBar = (props) => {
  return (
    <div class="col-lg-4 sidebar visit-sidebar ">
      {props.companies?.map((item, index) => (
        <Collapse
          className={
            item.id === props.id
              ? "visit-cards-collaps-header active-collapse-visit "
              : "visit-cards-collaps-header "
          }
          expandIcon={({ isActive }) =>
            isActive ? <FiChevronUp /> : <FiChevronDown />
          }
          style={{ marginBottom: 5 }}
          expandIconPosition="right"
          items={[
            {
              key: String("collapse" + index),
              label: item.name,

              children: <DateVisit branches={item?.branchList} />,
            },
          ]}
        />
      ))}
    </div>
  );
};

const DateVisit = (props) => {
  const { id, doctorid } = useParams();
  return (
    <Card className="doctors-sidebar">
      {props.branches.map((item) => (
        <div className="department-contacts-branchcard">
          <div className="doctor-contacts">
            <div className="col-lg-5 col-5">
              <div className="doctor-contanctsinfo-title">
                <FiPhone className="phone-icon" />
                شماره‌تماس:
              </div>

              <div className="doctor-contanctsinfo-title">
                <FiMapPin />
                آدرس:
              </div>
            </div>
            <div className="col-lg-7  col-7">
              <div className="doctor-contanctsinfo-value">
                {item.phoneList.map((ite, index) => (
                  <>
                    <a>{ite.phoneNo}</a>
                    {item?.phoneList?.length - 1 !== index && "-"}
                  </>
                ))}
              </div>
              <a className="doctor-contanctsinfo-value">{item.address}</a>
            </div>
          </div>
          <Link
            to={"/visit/" + doctorid + "/" + item?.id}
            className="sidebar-getvisit-btn"
          >
            دریافت نوبت
          </Link>
        </div>
      ))}
    </Card>
  );
};
